import Dialog  from "../../../GenericComponents/dialog";


interface FindWorkspaceDialogProps {
    isOpen: boolean;
    onClose: () => void;
}

const PatientCaseLookupDialog: React.FC<FindWorkspaceDialogProps> = ({ isOpen, onClose }) => {
  return (
    <Dialog
      isOpen={isOpen}
      title="Patient / Case Lookup"
      onClose={onClose}
      buttons={[
        {
          label: "Close",
          onClick: onClose,
          className: "ui-button ui-corner-all ui-widget app-button",
        },
      ]}
      width="100%"
      height="auto"
      maxWidth={960}
    >
      <div id="patient_lookup_dialog_wrapper" className="hide ui-dialog-content ui-widget-content" style={{ display: 'block', zIndex: 9999, width: 'auto', minHeight: '43.6px', maxHeight: 'none', height: 'auto' }}>
        <div id="patient_loading" className="ajax-loading-box popup-loading hide">
          <span className="ajax-loading-image"></span> Loading...
        </div>

        <div id="patient_search" className="patient-search hide" style={{ display: 'block' }}>
          <div className="patient-mrn-search">
            <div className="label">MRN:</div>
            <div className="input">
              <input
                type="text"
                id="text_patient_mrn_search"
                maxLength={40}
                size={10}
                value=""
                onChange={(e) => {}}
              />
            </div>
            <div className="button">
              <button
                id="button_patient_mrn_search"
                type="button"
                className="ui-button app-button"
                onClick={() => console.log("MRN")}
              >
                <span className="ui-button-text">Find</span>
              </button>
            </div>
          </div>

          <div className="patient-acc-search">
            <div className="label">Accession Number:</div>
            <div className="input">
              <input
                type="text"
                id="text_patient_acc_search"
                maxLength={40}
                size={10}
                value=""
                onChange={(e) => {}}
              />
            </div>
            <div className="button">
              <button
                id="button_patient_acc_search"
                type="button"
                className="ui-button app-button"
                onClick={() => console.log("ACC")}
              >
                <span className="ui-button-text">Find</span>
              </button>
            </div>
          </div>
          <div className="clear-both"></div>
        </div>

        <div id="patient_view_message" className="hide"></div>

        <div id="patient_data" className="patient-data hide" style={{ display: 'none' }}>
          {/* Add your patient data content here */}
        </div>
      </div>

      {/* <div className="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
        <div className="ui-dialog-buttonset">
          <button type="button" className="ui-button ui-corner-all ui-widget app-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div> */}
    </Dialog>
  );
};

export default PatientCaseLookupDialog;
